import { LoggedOutLayout } from "../components"
import { QrLoginQRStep } from "../components/QrLoginQRStep/QrLogin";
import { memo } from "react";

const QrLoginScreen = () => {
    return (
        <LoggedOutLayout>
            <QrLoginQRStep />;
        </LoggedOutLayout>
    )
}

export default memo(QrLoginScreen);